var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiSummary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.304,
    height: 21.302,
    viewBox: "0 0 19.304 21.302",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_57680",
    "data-name": "Group 57680",
    transform: "translate(-12029.608 19659.332)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "book_4_spark_24dp_5F6368_FILL1_wght400_GRAD0_opsz24",
    d: "M189.259-900.7a9.313,9.313,0,0,1,2.808-6.844,9.312,9.312,0,0,1,6.844-2.808,9.312,9.312,0,0,1-6.844-2.808A9.312,9.312,0,0,1,189.259-920a9.312,9.312,0,0,1-2.808,6.844,9.312,9.312,0,0,1-6.844,2.808,9.312,9.312,0,0,1,6.844,2.808A9.313,9.313,0,0,1,189.259-900.7Z",
    transform: "translate(11850.002 -18737.334)",
    fill: "#1aa9b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "book_4_spark_24dp_5F6368_FILL1_wght400_GRAD0_opsz24-2",
    "data-name": "book_4_spark_24dp_5F6368_FILL1_wght400_GRAD0_opsz24",
    d: "M183.962-910.348a4.924,4.924,0,0,1,1.267-3.422,4,4,0,0,1,3.088-1.4,4,4,0,0,1-3.088-1.4A4.923,4.923,0,0,1,183.962-920a4.923,4.923,0,0,1-1.267,3.422,4,4,0,0,1-3.088,1.4,4,4,0,0,1,3.088,1.4A4.924,4.924,0,0,1,183.962-910.348Z",
    transform: "translate(11860.596 -18739.332)",
    fill: "#1aa9b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "book_4_spark_24dp_5F6368_FILL1_wght400_GRAD0_opsz24-3",
    "data-name": "book_4_spark_24dp_5F6368_FILL1_wght400_GRAD0_opsz24",
    d: "M182.693-913.341a3.346,3.346,0,0,1,.9-2.361,2.872,2.872,0,0,1,2.189-.969,2.871,2.871,0,0,1-2.189-.969,3.345,3.345,0,0,1-.9-2.361,3.345,3.345,0,0,1-.9,2.361,2.871,2.871,0,0,1-2.189.969,2.872,2.872,0,0,1,2.189.969A3.346,3.346,0,0,1,182.693-913.341Z",
    transform: "translate(11851.253 -18737.838)",
    fill: "#1aa9b4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiSummary);
export default __webpack_public_path__ + "static/media/ai-summary.e6648561f1298791dc56d27ebb736fb3.svg";
export { ForwardRef as ReactComponent };